import React from 'react';
import MethodsTable from './methodsTable';
import ConfirmationModal from '../../../common/confirmationModal';
import OneInputEditModal from '../../../common/OneInputEditModal';

export default function DeliveryMethods({
	addValue,
	editValue,
	onChange,
	onUpdate,
	methods,
	onAdd,
	onChangeEdit,
	onMethodUpdateOrDelete,
	onDelete,
}) {
	return (
		<>
			<div className="comp-heading">
				<div className="row">
					<div className="col-lg-4">
						<label>Delivery Methods</label>
					</div>
				</div>
			</div>
			<br />
			<div className="panel panel-default">
				<div className="panel-body">
					<div className="row" id="settings-field">
						<div className="col-md-2 col-xs-9">
							<label className="input-label" htmlFor="delivery_method">
								* Delivery Method
							</label>
							<input
								value={addValue}
								onChange={e => onChange(e)}
								className="form-control"
								id="delivery_method"
							/>
						</div>
						<div className="col-xs-2" id="system-add-btn">
							<button onClick={() => onAdd()} className="btn btn-success btn-sm">
								Add
							</button>
						</div>
					</div>
				</div>
			</div>
			<div className="panel panel-default">
				<div className="panel-body">
					<MethodsTable onMethodUpdateOrDelete={data => onMethodUpdateOrDelete(data)} methods={methods} />
				</div>
			</div>
			<ConfirmationModal onDelete={() => onDelete()} item="Delivery Method" />
			<OneInputEditModal
				label="Delivery Method"
				value={editValue}
				onChange={e => onChangeEdit(e)}
				onUpdate={() => onUpdate()}
			/>
		</>
	);
}
